import {
  ICON_CLIPBOARD_TEXT_OUTLINE, useNotifications,
} from '@doveit/bricks';
import React, { FunctionComponent, useState } from 'react';
import WelcomeBox from '../../../components/welcome-box/WelcomeBox';
import { CallContextType, ProcessableContact } from '../../../providers/api/dtos';
import { useContactToProcessCount } from '../../hooks/use-contact-to-process-count/useContactToProcessCount';
import { getNextFeedbackContactId } from '../../../providers/api/call-center/callCenterFeedbackProvider';

export const START_FEEDBACK_ERROR_MESSAGE = 'Errore durante il caricamento del prossimo contatto: riprova più tardi.';

export interface StartFeedbackProcessProps {
  onNextContact: (processableContact?: ProcessableContact) => void,
}

const StartFeedbackProcess: FunctionComponent<StartFeedbackProcessProps> = ({
  onNextContact,
}) => {
  const [isStarting, setIsStarting] = useState(false);
  const {
    data: feedbackContactCount, isLoading: isFeedbackContactCountLoading, mutate: mutateFeedbackContactCount, error: feedbackContactCountError,
  } = useContactToProcessCount(CallContextType.SURVEY);
  const { addError } = useNotifications();

  const startProcessFeedback = React.useCallback(async () => {
    setIsStarting(true);

    try {
      const processableContact = await getNextFeedbackContactId();

      setIsStarting(false);

      onNextContact(processableContact);
    } catch (err) {
      setIsStarting(false);

      addError(START_FEEDBACK_ERROR_MESSAGE);
    }
  }, [addError, onNextContact]);

  return (
    <WelcomeBox
      icon={ICON_CLIPBOARD_TEXT_OUTLINE}
      label="survey"
      loading={isStarting}
      count={feedbackContactCount?.count}
      isContactCountError={!!feedbackContactCountError}
      isContactCountLoading={isFeedbackContactCountLoading}
      onStartClick={startProcessFeedback}
      onRefreshClick={mutateFeedbackContactCount}
    />
  );
};

export default StartFeedbackProcess;
